/*
 * Copyright 2026 Sony Corporation
 */

import type { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh';
import type { Scene } from '@babylonjs/core/scene';
import type { TransformNode } from '@babylonjs/core/Meshes/transformNode';

import type { Disposables } from './disposables';
import { restoreGlobals, type SceneGlobals } from './globals';
import type { Bounds, DefaultView, SceneInstance } from './types';

export interface SceneInstanceParts {
  sceneId: string;
  scene: Scene;
  root: TransformNode;
  bounds: Bounds;
  defaultView: DefaultView;
  shadowCasters?: AbstractMesh[];
  /** Everything the scene created, including its root. */
  own: Disposables;
  globals: SceneGlobals;
}

export const createSceneInstance = ({
  sceneId,
  scene,
  root,
  bounds,
  defaultView,
  shadowCasters = [],
  own,
  globals,
}: SceneInstanceParts): SceneInstance => {
  let disposed = false;

  return {
    sceneId,
    root,
    bounds,
    defaultView,
    shadowCasters,
    dispose: () => {
      if (disposed) {
        return;
      }
      disposed = true;
      restoreGlobals(scene, globals);
      own.dispose();
    },
  };
};
